import RefragLogo from '../assets/logos/refrag-horz-fill.svg';
import HalloweenLogo from '../assets/logos/refrag-halloween.svg';

// Halloween wordmark until 2026-11-01 01:00 UTC-12.
// The visitor's clock switches it back on the next page load.
export const logoAt = (now) => (now < Date.parse('2026-11-01T13:00:00Z') ? HalloweenLogo : RefragLogo);

export default logoAt(Date.now());
